import $ from "jquery";
import "what-input";

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
// require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import "./lib/foundation-explicit-pieces";
import "hc-sticky/dist/hc-sticky";
import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import "lazysizes";
import "masonry-layout/dist/masonry.pkgd";
import "imagesloaded/imagesloaded.pkgd";
import AOS from "aos";

$(document).foundation();

var engineUtils = {
  init: function () {
    this.ui.init();
  },

  ui: {
    init: function () {
      engineUtils.ui.layout();
      engineUtils.ui.plugins();
    },

    layout: function () {
      // Directions
      var directionVal =
        $("html").css("direction").toLowerCase() === "rtl" ? "rtl" : "ltr";

      //go to

      $(
        '.main-header a[href^="#"], .main-header a[href^="/#"], .navpanel a[href^="#"], .navpanel a[href^="/#"]'
      ).on("click", function (e) {
        // e.preventDefault();

        var target = this.hash,
          $target = $(target);

        // setTimeout(function () {
        $("html, body")
          .stop()
          .animate(
            {
              scrollTop: $target.offset().top - 100,
            },
            200,
            "swing",
            function () {
              window.location.hash = target;
            }
          );

        setTimeout(function () {
          $("html, body")
            .stop()
            .animate(
              {
                scrollTop: $target.offset().top,
              },
              100,
              function () {
                window.location.hash = target;
              }
            );
        }, 1500);
      });

      // Video Players
      if ($(".card-video").length) {
        $(".card-video").each(function () {
          var $id = $(this).attr("id");
          var $thumb = $(".card__img");
          var $videoId = $(this).data("video-id");
          var heroPlayer = jwplayer($id);
          var vRatio = "16:9";
          var dataControls = $(this).data("controls");

          if (!$(this).data("video-ratio") == "") {
            vRatio = $(this).data("video-ratio");
          } else {
            vRatio = "16:9";
          }

          if ($(this).data("controls") == "") {
            dataControls = $(this).data("controls");
          } else {
            dataControls = true;
          }

          if (Foundation.MediaQuery.is("medium up") == true) {
            vRatio;
            $videoId;
          } else {
            vRatio = "9:16";
            $videoId = $(this).data("videosm-id");
          }

          if ($(this).attr("id") == "cardVideoHero1") {
            vRatio = "16:9";
          }

          var jwplayerApi = "https://cdn.jwplayer.com/v2/media/" + $videoId;

          fetch(jwplayerApi)
            .then((response) => response.json())
            .then((responseData) => {
              var videoData = responseData.playlist[0];
              var videoUrl = videoData.sources
                .filter((item) => item.type == "video/mp4")
                .slice(-1)[0].file;
              var videoImgUrl = videoData.images.slice(-1)[0].src;

              heroPlayer.setup({
                file: videoUrl,
                image: videoImgUrl,
                autostart: false,
                allowFullscreen: false,
                responsive: true,
                aspectratio: vRatio,
                autostart: true,
                mute: true,
                repeat: true,
                controls: dataControls,
              });

              heroPlayer.on("play", function () {
                $($thumb).addClass("playing");
                // $(".main-hero__footer").hide();
              });

              heroPlayer.on("pause", function () {
                $($thumb).removeClass("playing");
                //$(".main-hero__footer").show();
              });

              $($thumb).on("click", function () {
                heroPlayer.play();
              });
            });
        });
      }
      // Modal
      if ($(".modal-toggle").length) {
        // text modal
        $(".modal-toggle").each(function () {
          var $this = $(this);

          $(this).on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            var modalId, itemIndex, modalAttribute;

            if ($this.hasClass("btn")) {
              itemIndex = $this.parents(".modal-toggle").data("index");
              modalAttribute = $this.parents(".modal-toggle").data("modal");
            } else {
              itemIndex = $this.data("index") - 1;
              modalAttribute = $this.data("modal");
            }

            // get modal
            modalId = "#" + modalAttribute;
            // toggle show modal
            $(modalId).toggleClass("is-visible");

            close(modalAttribute);

            // splide inside modal function
            // if mobile details is clicked
            if (typeof $(this).data("index") !== "undefined") {
              toggleSplide(modalAttribute, itemIndex);
            }
          });
        });

        //masterclass modal
        // $(".card-masterclass.modal-toggle").each(function () {
        //   var $this = $(this);

        //   $(this).on("click", function (e) {
        //     e.preventDefault();
        //     e.stopPropagation();
        //     var modalId, itemIndex, modalAttribute;

        //     // if mobile details is clicked
        //     if ($this.hasClass("btn")) {
        //       itemIndex = $this.parents(".modal-toggle").data("index");
        //       modalAttribute = $this.parents(".modal-toggle").data("modal");
        //     } else {
        //       itemIndex = $this.data("index") - 1;
        //       modalAttribute = $this.data("modal");
        //     }

        //     // get modal
        //     modalId = "#" + modalAttribute;
        //     // toggle show modal
        //     $(modalId).toggleClass("is-visible");

        //     // splide inside modal function
        //     toggleSplide(modalAttribute, itemIndex);
        //   });
        // });

        $(".card-masterclass__btn").on("click", function (e) {
          e.stopPropagation();
          return true;
        });

        // MOdal Video

        function playVideoModal(itemId, itemVideIdLg, itemVideoIdSm, action) {
          var $id = itemId;
          var $thumb = $(".card__img");
          var $videoId = itemVideIdLg;
          var heroPlayer = jwplayer($id);
          var vRatio = "9:16";
          var w, h;
          var dataControls = $(this).data("controls");

          // if (!$(this).data("video-ratio") == "") {
          //   vRatio = $(this).data("video-ratio");
          // } else {
          //   vRatio = "16:9";
          // }

          // if ($(this).data("controls") == "") {
          //   dataControls = $(this).data("controls");
          // } else {
          //   dataControls = true;
          // }

          if (Foundation.MediaQuery.is("medium up") == true) {
            w = 514;
            h = 713;
          } else {
            w = "100%";
            h = 521;
          }

          var jwplayerApi = "https://cdn.jwplayer.com/v2/media/" + $videoId;

          fetch(jwplayerApi)
            .then((response) => response.json())
            .then((responseData) => {
              var videoData = responseData.playlist[0];
              var videoUrl = videoData.sources
                .filter((item) => item.type == "video/mp4")
                .slice(-1)[0].file;
              var videoImgUrl = videoData.images.slice(-1)[0].src;

              heroPlayer.setup({
                file: videoUrl,
                image: videoImgUrl,
                autostart: false,
                allowFullscreen: false,
                responsive: true,
                aspectratio: vRatio,
                autostart: "viewable",
                mute: true,
                repeat: true,
                width: w,
                height: h,
                // controls: dataControls,

                // width: 100%,
                // height: 521,
              });

              heroPlayer.on("play", function () {
                $($thumb).addClass("playing");
                // $(".main-hero__footer").hide();
              });

              heroPlayer.on("pause", function () {
                $($thumb).removeClass("playing");
                //$(".main-hero__footer").show();
              });

              $($thumb).on("click", function () {
                heroPlayer.play();
              });
            });

          $(".modal-close, .modal-overlay").on("click", function () {
            heroPlayer.pause();
          });

          if (action == "play") {
            heroPlayer.play();
          }
        }

        // Modal Splide
        function toggleSplide(element, index) {
          var modal = "#" + element;
          // close modal
          $(".modal-close, .modal-overlay").on("click", function () {
            $(modal).removeClass("is-visible");
          });

          if ($(".masterclass-splide").length) {
            var masterclassSplide = new Splide(
              modal + " " + ".masterclass-splide",
              {
                arrows: true,
                pagination: false,
                type: "fade",
                //direction: directionVal,
                //  direction: "rtl",
              }
            );

            masterclassSplide.on("active", function (e) {
              if (
                $(e.slide).has(".masterclass-modal__img--video .modal-video")
                  .length
              ) {
                var $this = $(e.slide)
                  .has(".masterclass-modal__img--video")
                  .find(".modal-video");

                var id = $this.attr("id");
                var videoIdLg = $this.attr("data-video-id");
                var videoIdSm = $this.attr("data-videosm-id");

                $(e.slide)
                  .has(".masterclass-modal__img--video")
                  .addClass("played-video-modal");

                playVideoModal(id, videoIdLg, videoIdSm, "play");
              } else if (
                $(e.slide).has(".masterclass-modal__img--video .jwplayer")
                  .length
              ) {
                jwplayer(
                  $(e.slide)
                    .has(".masterclass-modal__img--video")
                    .find(".jwplayer")
                    .attr("id")
                ).play();
              } else {
                if ($(".played-video-modal").length) {
                  jwplayer(
                    $(".played-video-modal .jwplayer").attr("id")
                  ).pause();

                  $(".masterclass-modal__img--video").removeClass(
                    "played-video-modal"
                  );
                }
              }
            });

            masterclassSplide.mount();

            masterclassSplide.go(index);
          }
        }

        // var masterclassSplide = new Splide(".masterclass-splide", {
        //   type: "fade",
        //   pagination: false,
        //   arrows: true,
        // });

        // masterclassSplide.mount();

        // Modal Splide
        function close(element) {
          var modal = "#" + element;
          // close modal
          $(".modal-close, .modal-overlay").on("click", function () {
            $(modal).removeClass("is-visible");
          });
        }

        // // dont include button to be clicked on modal
        // $(".modal-toggle .btn").on("click", function (e) {
        //   e.stopPropagation();
        // });

        // when user press esc close modal
        $(document).keyup(function (e) {
          if (e.key === "Escape") {
            // escape key maps to keycode `27`
            $(".modal.is-visible").removeClass("is-visible");
          }
        });
      }

      // Discover splide
      if ($(".discover-main").length) {
        $(".discover-main").each(function (i, n) {
          var slideDirection = $(this).attr("data-moveto");
          var slideRewind = $(this).attr("data-rewind");
          var slideStart = $(this).attr("data-start-index");

          var discoverMain = new Splide(this, {
            pagination: false,
            arrows: false,
            direction: slideDirection,
            type: "loop",
            //perPage: 3,
            autoWidth: true,
            start: slideStart,
            autoScroll: {
              speed: -1,
            },
          });

          //discoverMain.mount();
          discoverMain.mount({ AutoScroll });
        });
      }

      // Partners splide
      if ($(".partners-main").length) {
        $(".partners-main").each(function (i, n) {
          var slideDirection = $(this).attr("data-moveto");
          var slideStart = $(this).attr("data-start-index");

          var partnersMain = new Splide(this, {
            pagination: false,
            arrows: false,
            direction: slideDirection,
            type: "loop",
            autoWidth: true,
            start: slideStart,
            autoScroll: {
              speed: -1,
            },
          });
          //partnersMain.mount();
          partnersMain.mount({ AutoScroll });
        });
      }

      // Sponsors splide
      if ($(".sponsors-main").length) {
        $(".sponsors-main").each(function (i, n) {
          var slideDirection = $(this).attr("data-moveto");

          var sponsorsMain = new Splide(this, {
            pagination: false,
            arrows: false,
            direction: slideDirection,
            type: "loop",
            autoWidth: true,
            autoScroll: {
              speed: 1,
            },
          });
          sponsorsMain.mount({ AutoScroll });
        });
      }

      // Journey splide
      if ($(".journey-main").length) {
        $(".journey-main").each(function (i, n) {
          var journeyMain = new Splide(this, {
            pagination: false,
            arrows: false,
            direction: directionVal,
            autoWidth: true,
            autoScroll: {
              speed: -1,
            },
          });

          journeyMain.mount();
        });
      }

      // sticky header
      if ($("#sticky-header").length) {
        var stickyHeader = new hcSticky("#sticky-header", {
          stickTo: "body",
          onStart: function onStart() {
            $(".intro").slideUp();
          },
          onStop: function onStop() {
            $(".intro").slideDown("fast");
          },
        });
      }

      // sticky sidebars
      if ($(".is-sticky").length) {
        var stickySide = document.getElementsByClassName("is-sticky");

        for (var i = 0; i < stickySide.length; i++) {
          new hcSticky(stickySide[i], {
            stickTo: stickySide[i].parentNode.parentNode,
            top: 0,
          });
        }
      }

      var stickyButton = document.getElementsByClassName("section__header-cta");

      for (var i = 0; i < stickyButton.length; i++) {
        // new hcSticky(stickyButton[i], {
        //   stickTo: "main", // stickyButton[i].parentNode.parentNode.parentNode,
        //   innerSticker: stickyButton[i].parentNode.parentNode.parentNode,
        // });
        // console.log(stickyButton[i].parentNode.parentNode.parentNode, "node");
      }

      // var StickyBtn = new hcSticky("#main-workshop", {
      //   stickTo: "main",
      //   innerSticker: ".section__header-cta",
      //   responsive: {
      //     980: {
      //       disable: true,
      //     },
      //   },
      // });

      // filter button mobile
      if ($(".filter-btn").length) {
        $(".filter-btn").on("click", function () {
          $(".filter").toggleClass("open");
        });
      }

      //Nav Toggle
      if ($(".nav-toggle-btn").length) {
        $(".nav-toggle-btn").on("click", function () {
          $(this).toggleClass("active");
          $(".navpanel").toggleClass("active");
        });

        $(".navpanel .nav__item a").on("click", function (event) {
          $(".navpanel").toggleClass("active");
          $(".nav-toggle-btn").toggleClass("active");
        });

        $(window).on("load", function () {
          if (window.location.hash !== "") {
            var target = window.location.hash,
              $target = $(target);

            $("html, body")
              .stop()
              .animate(
                {
                  scrollTop: $target.offset().top - 100,
                },
                200,
                "swing",
                function () {
                  window.location.hash = target;
                }
              );

            setTimeout(function () {
              $("html, body")
                .stop()
                .animate(
                  {
                    scrollTop: $target.offset().top,
                  },
                  100,
                  function () {
                    window.location.hash = target;
                  }
                );
            }, 1500);

            // var hash = window.location.hash;
            // $("html, body").animate(
            //   {
            //     scrollTop: $(hash).offset().top,
            //   },
            //   800,
            //   function () {}
            // );
          }
        });
      }

      // Window Scroll
      var lastScrollTop = 65;
      $(window).on("scroll", function (event) {
        var st = $(this).scrollTop();
        if (st > lastScrollTop) {
          $("body").addClass("page-scrolling-down");
        } else {
          $("body").removeClass("page-scrolling-down");
        }
        lastScrollTop = st;
      });

      // SKINCARE VIDEO
      if ($(".skincare-video").length) {
        $(".skincare-video").each(function () {
          var $id = $(this).attr("id");
          // var $thumb = $(".card__img", this);
          var $videoId = $(this).data("video-id");
          var skincarePlayer = jwplayer($id);
          var vRatio = "16:9";

          if (Foundation.MediaQuery.is("medium up") == true) {
            vRatio;
            $videoId;
          } else {
            vRatio = "9:16";
            $videoId = $(this).data("videosm-id");
          }

          var jwplayerApi = "https://cdn.jwplayer.com/v2/media/" + $videoId;

          fetch(jwplayerApi)
            .then((response) => response.json())
            .then((responseData) => {
              var videoData = responseData.playlist[0];
              var videoUrl = videoData.sources
                .filter((item) => item.type == "video/mp4")
                .slice(-1)[0].file;
              // var videoImgUrl = videoData.images.slice(-1)[0].src;

              skincarePlayer.setup({
                file: videoUrl,
                autoPause: {
                  viewability: false,
                },
                autostart: "viewable",
                allowFullscreen: false,
                responsive: true,
                mute: true,
                aspectratio: vRatio,
                repeat: true,
              });
            });
        });
      }

      // performance splide
      // if ($(".performance-splide").length) {
      //   var splidePerformance = new Splide(".performance-splide", {
      //     direction: directionVal,
      //     pagination: false,
      //     arrows: false,
      //     type: "loop",
      //     destroy: true,
      //     breakpoints: {
      //       600: {
      //         padding: { right: 20 },
      //         destroy: false,
      //       },
      //     },
      //   });

      //   if (directionVal == "rtl" && Foundation.MediaQuery.is("small only")) {
      //     splidePerformance.on("ready", function () {
      //       splidePerformance.options = {
      //         padding: { left: 20, right: 0 },
      //       };
      //     });
      //   }

      //   splidePerformance.mount();
      // }

      // Performances
      if ($(".performances .tabs-title").length) {
        $(".performances .tabs-title").on("mouseenter", function () {
          $(this).find("a").click();
        });

        // load More items on mobile

        $("#loadMorePerformance").on("click", function () {
          $(".performances #performance-tabs li").show();
          $(this).hide();
        });
      }

      // Skincare Talk and Panels Tab

      if ($("#talkpanels-tabs").length) {
        // on change panels change btn link
        $("#talkpanels-tabs").on("change.zf.tabs", function () {
          var btn = $("#talkpanels-tabs")
            .parents(".section")
            .find(".btn--talk-panels");

          var tab1Link, tab2Link;

          if ($("html:lang(en)").length > 0) {
            (tab1Link =
              "https://hiahub.platinumlist.net/event/hiahub-professional-pass/casual-ticket-office?id_event_show=2461684"),
              (tab2Link =
                "https://hiahub.platinumlist.net/event/hiahub-professional-pass/casual-ticket-office?id_event_show=2461685");
          } else {
            (tab1Link =
              "https://hiahub.platinumlist.net/ar/event/hiahub-professional-pass/casual-ticket-office?id_event_show=2461684"),
              (tab2Link =
                "https://hiahub.platinumlist.net/ar/event/hiahub-professional-pass/casual-ticket-office?id_event_show=2461685");
          }

          if ($("#panel1:visible").length) {
            btn.attr("href", tab1Link);
          } else if ($("#panel2:visible").length) {
            btn.attr("href", tab2Link);
          }
        });

        //get Date
        var d = new Date();
        var strDate =
          d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate();

        //if date Today is Nov 1 change active tab to Nov 1

        if (strDate == "2024/11/01") {
          // CHANGE ACTIVE TAB BASED ON THE DATE
          var $targetClose = $(".tab-oct31");
          $("#talkpanels-tabs").foundation("_collapseTab", $targetClose);

          var $targetOpen = $(".tab-nov1");
          $("#talkpanels-tabs").foundation("_openTab", $targetOpen);
        }
      }

      //counter

      if ($(".counter_js").length) {
        var list = $(".counter_js .card-masterclass");

        for (let i = 0; i <= list.length; i++) {
          list.eq(i).attr("data-index", `${i + 1}`);
        }
      }

      // Schedule filter

      // if ($(".activitiesFilter_js").length) {
      //   var defaultList = $("#skincarePanel2 .program-item").html();
      //   //console.log(defaultList, "default");

      //   $(".activitiesFilter_js").on("change", function () {
      //     var selectedValue = this.value;

      //     //console.log(selectedValue, "selectedValue");

      //     // var category = "FF + SCE";
      //     var filteredActivities = $(
      //       defaultList,
      //       "#skincarePanel2 .program"
      //     ).filter('[data-activities="' + selectedValue + '"]');
      //     // console.log(filteredActivities, "filteredActivities");

      //     if (selectedValue == "all") {
      //       $("#skincarePanel2 .program-item").html(defaultList);
      //     } else {
      //       $("#skincarePanel2 .program-item").html(filteredActivities);
      //     }

      //     // var defaultContent = $("#skincarePanel2 .program-item").html();
      //     // console.log(defaultContent, "default");

      //     // var filteredActivities = $(
      //     //   "#skincarePanel2 .program[data-activities= " +
      //     //     '"' +
      //     //     selectedValue +
      //     //     '"' +
      //     //     "]"
      //     // ).each(function () {
      //     //   return this;
      //     // });

      //     // $("#skincarePanel2 .program-item").html(filteredActivities);

      //     // console.log(filteredActivities, "filteredActivities");
      //   });
      // }

      // Schedule filter
      if ($(".filter_js").length) {
        var filters = [];

        if (Foundation.MediaQuery.is("medium up") == true) {
          $(".filter__label").on("click", function () {
            $(this).next().slideToggle();
            $(this).toggleClass("active");
          });
        }

        $(".filter_js input[type='checkbox']").on("change", function () {
          if (filters.indexOf(this.value) > -1) {
            filters.splice(filters.indexOf(this.value), 1);
          } else {
            filters.push(this.value);
          }

          if (filters.length > 0) {
            $(".program").hide();
            $(".program").each(function (i) {
              filters.map((item) => {
                if ($(this).data("categories").includes(item)) {
                  $(this).show();
                }
              });
            });
          } else {
            $(".program").show();
          }
        });
      }

      // if ($(".filter_js").length) {
      //   var currentTab;

      //   currentTab = $(".schedule-tabs-content .is-active").attr("id");

      //   currentTabId(currentTab);

      //   var defaultHtml = [];

      //   // default HTML of each tabs
      //   $(".schedule-tabs-content .tabs-panel").each(function (index, el) {
      //     var _this = $(this);
      //     var id = _this.attr("id");

      //     defaultHtml[index] = [];

      //     $("#" + `${id}` + " .program-item").each(function (key, value) {
      //       defaultHtml[index][key] = $(value).html();
      //     });
      //   });

      //   // if Tabs has been clicked
      //   $("#schedule-tabs").on("change.zf.tabs", function () {
      //     var id = $('div[data-tabs-content="' + $(this).attr("id") + '"]')
      //       .find(".tabs-panel.is-active")
      //       .attr("id");

      //     currentTabId(id);
      //   });

      //   function currentTabId(currentId) {
      //     currentTab = currentId;

      //     var defaultList = $("#" + `${currentTab} ` + ".program-item").html();

      //     var dVal = [];
      //     var fVal = [];

      //     $("#" + `${currentTab} ` + ".program-item .program").each(
      //       function () {
      //         dVal.push(this);
      //       }
      //     );

      //     // if filter is > 0
      //     if ($(".filter_js input[type='checkbox']:checked").length > 0) {
      //       activitiesFilter();
      //     } else {
      //       // none
      //     }

      //     // on change checkbox
      //     $(".filter_js input[type='checkbox']").on("change", function () {
      //       if ($(".filter_js input[type='checkbox']:checked").length > 0) {
      //         activitiesFilter();
      //       } else {
      //         //return to default items
      //         $(".program-item").each(function (index) {
      //           $(this).html(defaultHtml[index]);
      //         });
      //       }
      //     });

      //     function activitiesFilter() {
      //       fVal = [];
      //       var activityFilters = [];

      //       $(".filter_js input[type='checkbox']:checked").each(function (i) {
      //         activityFilters.push(this.value);
      //       });

      //       dVal.map((item) => {
      //         activityFilters.map((fItem) => {
      //           if (item.dataset.categories.indexOf(fItem) > -1) {
      //             fVal.push(item);
      //           }
      //         });
      //       });

      //       $("#" + `${currentTab} ` + ".program-item").html(fVal);
      //     }
      //   }
      // }

      //Speakers remove redundant
      if ($(".cardSpeakers_js").length) {
        var seen = {};
        var seenModal = {};

        var parent = $(".cardSpeakers_js");
        parent.each(function () {
          //var dataItemName = $(this).find(".card-masterclass__name h2").html();
          var dataItemName = $(this).find(".card-masterclass__name h2").text();

          if (seen[dataItemName]) {
            //$(this).parent(".cardSpeakers_js").remove();
            $(this).parent().remove();
          } else {
            seen[dataItemName] = true;
          }

          //move dummy images to  the last
          $(this)
            .find($("img[src*='NA-Speaker--']"))
            .parents(".cell")
            .insertBefore($(".cell-subscribe"));
        });

        for (let i = 0; i <= $(".cardSpeakers_js").length; i++) {
          $(".cardSpeakers_js")
            .eq(i)
            .attr("data-index", `${i + 1}`);
        }

        // MODAL speaker - remove duplicate speakers
        var parentModal = $("#modal-speakers .splide__slide");
        parentModal.each(function () {
          //var dataItemName = $(this).find(".card-masterclass__name h2").html();
          var dataModalItemName = $(this)
            .find(".masterclass-modal__title")
            .text();

          if (seenModal[dataModalItemName]) {
            //$(this).parent(".cardSpeakers_js").remove();
            $(this).remove();

            //console.log($(this).parent(".cardSpeakers_js"), "this dup");
          } else {
            seenModal[dataModalItemName] = true;
          }

          // move dummy items to the last for MODAL
          $(".splide__list").append(
            $(this)
              .find($("img[src*='NA-Speaker--']"))
              .parents(".splide__slide")
          );
        });
      }

      if ($(".count_js").length) {
        var list = $(".card-masterclass");

        $(".count_js").html(list.length);
      }
    },

    plugins: function () {
      //AOS
      AOS.init();

      // Masonry
      var imageUrl;

      if ($("html").attr("dir") == "rtl") {
        imageUrl = "../assets/img/story/";
      } else {
        imageUrl = "assets/img/story/";
      }

      if ($(".story-masonry").length > 0) {
        var el = $(
          `   
            <div class="story-masonry__item-wrap">
              <div class="story-masonry__item">
              <img src="${imageUrl}11.png" alt="story" />
              </div>
            </div>
            </div>
            <div class="story-masonry__item-wrap">
              <div class="story-masonry__item">
              <img src="${imageUrl}13.png" alt="story" />
              </div>
            </div>
            </div>
            <div class="story-masonry__item-wrap">
              <div class="story-masonry__item">
              <img src="${imageUrl}14.png" alt="story" />
              </div> 
            </div>
          
            <div class="story-masonry__item-wrap">
              <div class="story-masonry__item">
              <img src="${imageUrl}16.png" alt="story" />
              </div> 
            </div>
            <div class="story-masonry__item-wrap">
              <div class="story-masonry__item">
              <img src="${imageUrl}17.png" alt="story" />
              </div> 
            </div>
            <div class="story-masonry__item-wrap">
              <div class="story-masonry__item">
              <img src="${imageUrl}18.png" alt="story" />
              </div> 
            </div>
            <div class="story-masonry__item-wrap">
              <div class="story-masonry__item">
              <img src="${imageUrl}19.png" alt="story" />
              </div> 
            </div>
            `
        );

        if (Foundation.MediaQuery.is("medium up") == true) {
          var $storyMasonry = $(".story-masonry").masonry({
            itemSelector: ".story-masonry__item-wrap",
            //columnWidth: 377.5,
            // columnWidth: ".grid-sizer",
            percentPosition: true,
            horizontalOrder: true,
            gutter: 32,
            originLeft: true,
            transitionDuration: "0.2s",
          });

          $storyMasonry.imagesLoaded().progress(function () {
            $storyMasonry.masonry();
          });

          $("#loadMore").on("click", function () {
            $storyMasonry
              .append(el)
              .masonry("appended", el)
              .masonry("reloadItems")
              .masonry();

            $storyMasonry.imagesLoaded().progress(function () {
              $storyMasonry.masonry();
            });

            $(this).hide();
          });
        } else {
          if ("#loadMore".length) {
            $(".story-masonry__last").hide();
            // $("#loadMore").on("click", function () {

            $(".story-masonry").append(el);

            // $(".story-masonry__last").hide();
            //  });
          }
        }
      }

      // group masonry for activities panels tab

      if ($("#group-masonry").length && $("#activities-tabs").length) {
        $("#activities-tabs").on("change.zf.tabs", function () {
          if ($("#panel3:visible").length) {
            if (Foundation.MediaQuery.is("medium up") == true) {
              var $groupMasonry = $("#group-masonry").masonry({
                itemSelector: ".activities-item",
                percentPosition: true,
                horizontalOrder: true,
                gutter: 32,
                originLeft: true,
                transitionDuration: "0.2s",
              });

              $groupMasonry.imagesLoaded().progress(function () {
                $groupMasonry.masonry();
              });
            }
          }
        });
      }

      if ($("#group-masonry").length && $(".panels-list").length) {
        if (Foundation.MediaQuery.is("medium up") == true) {
          var $groupMasonry = $("#group-masonry").masonry({
            itemSelector: ".panels-list__item",
            percentPosition: true,
            horizontalOrder: true,
            gutter: 32,
            originLeft: true,
            transitionDuration: "0.2s",
          });

          $groupMasonry.imagesLoaded().progress(function () {
            $groupMasonry.masonry();
          });
        }
      }
    },
  },
};

$(document).ready(function () {
  engineUtils.init();
});
